// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const finishSignUpPath = "/finishSignUp";

const getEmailLinkRedirectUrl = () => {
  if (process.env.REACT_APP_EMAIL_LINK_REDIRECT_URL) {
    return process.env.REACT_APP_EMAIL_LINK_REDIRECT_URL;
  }

  if (
    typeof window !== "undefined" &&
    (window.location.protocol === "http:" || window.location.protocol === "https:")
  ) {
    return `${window.location.origin}${finishSignUpPath}`;
  }

  return `https://${firebaseConfig.authDomain}${finishSignUpPath}`;
};

const emailLinkRedirectUrl = getEmailLinkRedirectUrl();

export const emailLinkActionCodeSettings = {
  url: emailLinkRedirectUrl,
  handleCodeInApp: true,
  linkDomain: process.env.REACT_APP_FIREBASE_LINK_DOMAIN || firebaseConfig.authDomain,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
